export const sendPostMessage = (data: Record<string, any>): void => {
    window.parent.postMessage(JSON.stringify(data), '*');
};
